import { Box } from "@mui/material";
import { format } from "date-fns";
import { AdminActionsPopover } from "./admin-actions-popover";
import { formatLabel } from "@/utils/format-label";
import { formatName } from "@/utils/format-name";
import { formatAccessType } from "@/utils/format-access-type";

export const AdminColumns = [
  {
    id: "fullName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Name / Email</div>,
    cell: ({ row }) => {
      const { firstName, surname, email } = row.original;
      return (
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ fontSize: "0.85rem" }}>
            {firstName && surname ? formatName(firstName, surname) : "N/A"}
          </div>
          <div style={{ fontSize: "0.75rem", color: "#6b7280" }}>
            {email ?? "N/A"}
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: "phoneNumber",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Phone</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.phoneNumber ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "accessType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Access Type</div>,
    cell: ({ row }) => {
      const access = row.original.accessType;
      return (
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: "#eef2ff",
            color: "#3730a3",
            fontSize: "0.75rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {formatAccessType(access) ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "customerType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Role</div>,
    cell: ({ row }) => {
      const role = row.original.customerType;
      return (
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: "#ecfdf5",
            color: "#065f46",
            fontSize: "0.75rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {formatLabel(role) ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "active",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const isActive = row.original.active;

      return (
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isActive ? "#ecfdf5" : "#fef2f2",
            color: isActive ? "#065f46" : "#991b1b",
            fontSize: "0.75rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {isActive ? "Active" : "Inactive"}
        </Box>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date Created</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;

      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      // API now returns createdAt as a Unix epoch (ms) timestamp
      const formattedDate = new Date(date);

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isNaN(formattedDate.getTime())
            ? "N/A"
            : format(formattedDate, "MMM d, yyyy")}
        </div>
      );
    },
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => <AdminActionsPopover admin={row.original} />,
  },
];
